import React from "react"

import Airtable from "airtable"

import { ChildSelector } from "../helpers/ChildSelector"

import * as applicationStyles from "../styles/Application.module.css"

const ISOCountries = require("i18n-iso-countries")
ISOCountries.registerLocale(require("i18n-iso-countries/langs/en.json"))

export default function Application(props) {
  const { content } = props

  const [, forceUpdate] = React.useReducer(x => x + 1, 0)

  const [isSubmitted, setSubmitted] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  const [data, setData] = React.useState({
    email: ``,
    firstName: ``,
    lastName: ``,
    phone: ``,
    company: ``,
    city: ``,
    country: ``,
    service: ``,
    style: ``,
    month: ``,
    registrations: [
      { name: `Administrator (PAW)`, checked: false },
      { name: `Administrator (Arc)`, checked: false },
      { name: `Advanced MDX (PAW)`, checked: false },
      { name: `Advanced Rules (PAW)`, checked: false },
      { name: `Advanced Rules (Arc)`, checked: false },
      { name: `Advanced Rules (Perspectives)`, checked: false },
      { name: `Advanced TurboIntegrator (PAW)`, checked: false },
      { name: `Advanced TurboIntegrator (Arc)`, checked: false },
      { name: `Advanced TurboIntegrator (Perspectives)`, checked: false },
      { name: `AI Ingtegration with watsconx.ai`, checked: false },
      { name: `Apliqo UX - Basic User`, checked: false },
      { name: `Apliqo UX - Power User: Advanced`, checked: false },
      { name: `Apliqo UX - Power User: Developers & Administrators`, checked: false },
      { name: `Apliqo UX - Power User: Fundamentals`, checked: false },
      { name: `Custom Report / Slice`, checked: false },
      { name: `Developer Fundamentals (PAW)`, checked: false },
      { name: `Developer Fundamentals (Arc)`, checked: false },
      { name: `Developer Fundamentals (Perspectives)`, checked: false },
      { name: `Dynamic Report / Active Forms`, checked: false },
      { name: `End User (Perspectives)`, checked: false },
      { name: `End User (Planning Analytics for Excel)`, checked: false },
      { name: `End User (Planning Analytics Workspace)`, checked: false },
      { name: `End User (Slice)`, checked: false },
      { name: `Exploration and Quick Report`, checked: false },
      { name: `MDX Fundamentals`, checked: false },
      { name: `Modelling - Sales`, checked: false },
      { name: `Pulse Fundamentals`, checked: false },
      { name: `TM1 Developer Credential`, checked: false },
      { name: `TM1py Fundamentals`, checked: false },
      { name: `Understanding the Value of Planning Analytics / TM1`, checked: false },
      { name: `Universal Report`, checked: false },
    ],
    notes: ``,
  })

  const handleItemChange = (evt, cat) => {
    let updated = data
    if (Object.keys(evt.target).includes(`checked`)) {
      if (cat) {
        updated[cat].find(({ name }) => name === evt.target.name).checked =
          evt.target.checked
      } else {
        updated[evt.target.name] = evt.target.checked
      }
    } else {
      updated[evt.target.name] = evt.target.value
    }

    setData(updated, forceUpdate())
  }

  const handleSubmit = evt => {
    evt.preventDefault()

    setHasError(false)

    let filteredData = JSON.parse(JSON.stringify(data))
    filteredData[`registrations`] = data[`registrations`]
      .reduce((prev, curr) => {
        if (curr.checked) return [...prev, curr.name]
        return prev
      }, [])
      .toString()
    filteredData.country = ISOCountries.getName(data.country, "en")

    const date = new Date()
    date.setMonth(data.month - 1)
    filteredData.month = date.toLocaleString("en-US", { month: "long" })

    const base = new Airtable({
      apiKey: process.env.GATSBY_AIRTABLE_API_TOKEN,
    }).base("appFjvD2K5rTdjHBH")

    base("TrainingEnquiries").create(
      [
        {
          fields: filteredData,
        },
      ],
      function (err, records) {
        if (err) {
          console.error(err)
          setHasError(true)
          return
        }
        records.forEach(function (record) {
          setSubmitted(true)
        })
      },
    )
  }

  const title = ChildSelector.select(
    content,
    `application-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <>
      <div className={`row ${applicationStyles.wrapper}`}>
        <div className={`col-12 ${applicationStyles.holder}`}>
          <h1
            className={`${applicationStyles.title}`}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        </div>
        {!isSubmitted && (
          <div className={`row ${applicationStyles.applicationWrapper}`}>
            <div className={`col-12 ${applicationStyles.submitApplication}`}>
              <form
                className={`row ${applicationStyles.applicationForm}`}
                onSubmit={handleSubmit}
              >
                <div className={`row ${applicationStyles}`}>
                  <div className={`col ${applicationStyles.info}`}>
                    <input
                      id="firstName"
                      type="text"
                      className="form-control"
                      placeholder="First name *"
                      aria-label="First name"
                      name="firstName"
                      value={data.firstName}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                  <div className={`col ${applicationStyles.info}`}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last name *"
                      aria-label="Last name"
                      id="lastName"
                      name="lastName"
                      value={data.lastName}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${applicationStyles}`}>
                  <div className={`col ${applicationStyles.info}`}>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email *"
                      aria-label="Email"
                      id="email"
                      name="email"
                      value={data.email}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${applicationStyles}`}>
                  <div className={`col ${applicationStyles.info}`}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Phone *"
                      aria-label="Phone"
                      id="phone"
                      name="phone"
                      value={data.phone}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${applicationStyles}`}>
                  <div className={`col ${applicationStyles.info}`}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company *"
                      aria-label="Company"
                      id="company"
                      name="company"
                      value={data.company}
                      required
                      onChange={handleItemChange}
                    />
                  </div>
                </div>
                <div className={`row ${applicationStyles}`}>
                  <div
                    className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ${applicationStyles.info} ${applicationStyles.location}`}
                  >
                    <label>
                      Which country are you located in? *
                      <select
                        value={data.country}
                        name="country"
                        required
                        onChange={handleItemChange}
                      >
                        <option value="" disabled defaultValue="">
                          Select a country
                        </option>
                        {Object.entries(
                          ISOCountries.getNames("EN", {
                            select: "official",
                          }),
                        ).map((country, idx) => (
                          <option key={idx} value={country[0]}>
                            {country[1]}
                          </option>
                        ))}
                      </select>
                    </label>
                  </div>
                  <div
                    className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ${applicationStyles.info} ${applicationStyles.locationCity}`}
                  >
                    <label>Which city are you located in? *</label>
                    <input
                      type="text"
                      className="form-control"
                      aria-label="City"
                      id="city"
                      name="city"
                      value={data.city}
                      onChange={handleItemChange}
                      required
                    />
                  </div>
                </div>
                <div className={`row ${applicationStyles.servicesWrapper}`}>
                  <div
                    className={`col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ${applicationStyles.service}`}
                  >
                    <label>
                      Which service are you interested in?
                      <select
                        value={data.service}
                        name="service"
                        onChange={handleItemChange}
                      >
                        <option value="" disabled defaultValue="">
                          Select a service
                        </option>
                        <option value="training">Training</option>
                        <option value="enduser">End User Membership</option>
                        <option value="powerUser">Power User Membership</option>
                        <option value="enterprise">
                          Enterprise Membership
                        </option>
                      </select>
                    </label>
                  </div>
                  <div className={`col ${applicationStyles.trainingStyle}`}>
                    {data.service === `training` && (
                      <label>
                        Training Style
                        <select
                          value={data.style}
                          name="style"
                          onChange={handleItemChange}
                        >
                          <option value="" disabled defaultValue="">
                            Select a training style
                          </option>
                          <option value="selfPaced">Self-paced</option>
                          <option value="online">Online Classroom</option>
                          <option value="inPerson">In-person Classroom</option>
                        </select>
                      </label>
                    )}
                  </div>
                </div>
                <div className={`row ${applicationStyles.scheduleWrapper}`}>
                  <div className={`col ${applicationStyles.schedule}`}>
                    <label>Which month do you want to commence?</label>
                    <select
                      value={data.month}
                      name="month"
                      onChange={handleItemChange}
                    >
                      <option value="" disabled defaultValue="">
                        Select a month
                      </option>
                      <option value="1">January</option>
                      <option value="2">February</option>
                      <option value="3">March</option>
                      <option value="4">April</option>
                      <option value="5">May</option>
                      <option value="6">June</option>
                      <option value="7">July</option>
                      <option value="8">August</option>
                      <option value="9">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </select>
                  </div>
                </div>
                <div className={`row ${applicationStyles.coursesWrapper}`}>
                  <div className={`col ${applicationStyles.courses}`}>
                    <label>Which course(s) do you want to register for?</label>
                  </div>
                  <div className={`row ${applicationStyles.courses}`}>
                    <div className={`col ${applicationStyles.courses}`}>
                      {data.registrations
                        .slice(0, Math.ceil(data.registrations.length / 2))
                        .map((it, idx) => (
                          <div key={idx} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={it.name}
                              checked={data.registrations[idx].checked}
                              onChange={evt =>
                                handleItemChange(evt, `registrations`)
                              }
                            />
                            <label className="form-check-label">
                              {it.name}
                            </label>
                          </div>
                        ))}
                    </div>
                    <div className={`col ${applicationStyles.courses}`}>
                      {data.registrations
                        .slice(Math.ceil(data.registrations.length / 2))
                        .map((it, idx) => (
                          <div key={idx} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name={it.name}
                              checked={
                                data.registrations[
                                  idx + Math.ceil(data.registrations.length / 2)
                                ].checked
                              }
                              onChange={evt =>
                                handleItemChange(evt, `registrations`)
                              }
                            />
                            <label className="form-check-label">
                              {it.name}
                            </label>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
                <div className={`col-12 ${applicationStyles.messageWrapper}`}>
                  <div className={`${applicationStyles.message}`}>
                    <label className="form-label">Further Notes</label>
                    <textarea
                      className="form-control"
                      name="notes"
                      rows="3"
                      values={data.notes}
                      onChange={handleItemChange}
                    ></textarea>
                  </div>
                </div>
                <div className={`row ${applicationStyles.formSubmit}`}>
                  <div className={`col ${applicationStyles.submit}`}>
                    <button type="submit" className={`${applicationStyles}`}>
                      Submit Enquiry
                    </button>
                    {hasError && (
                      <p>
                        An unexpected error has occurred. Please confirm all
                        data to be correctly input and try again...
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        {isSubmitted && (
          <>
            <h5>
              Thank you for reaching out.
              <br />
              We will be in touch soon!
            </h5>
            <br />
            <br />
            <br />
            <br />
          </>
        )}
      </div>
    </>
  )
}
